import { useFormik } from "formik";
import { publicIpv4 } from "public-ip";
import { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { validationMessage } from "../../../../Helper/helperfunction";
import { LeftArrowIcon } from "../../../../assets/icons/svgicons";
import {
  saveSignUpDetails
} from "../../../../features/persist/persistSlice";
import { forgotEmailAction } from "../../../../features/user/userSlice";
import { ROUTES } from "../../../../routes";
import { Messages, SERVICES, SERVICESTYPE, TYPE } from "../../../../utils/constants";
import Button from "../../../common/Button/Button";
import InputFormik from "../../../common/Formik/Input/InputFormik";
import styles from "../../../layouts/OnboardLayout/OnboardLayout.module.scss";
import passwordStyles from "./ForgotPasswordEmail.module.scss";

const ForgotPasswordEmail = () => {
  const history = useNavigate();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [ipAddress, setIpAddress] = useState("");
  const [submitPending, setSubmitPending] = useState(false);
  const submitLockRef = useRef(false);

  const validationSchema = Yup.object({
    email: Yup.string()
      .label("Email")
      .required(validationMessage("Email"))
      .email(Messages?.invalidEmail),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (submitLockRef.current) return;
      submitLockRef.current = true;
      setSubmitPending(true);

      const data = {
        username: values.email, // ✅ fixed
        type: SERVICESTYPE?.EMAIL,
        service: SERVICES?.FORGOTPASSWORD,
        ipAddress: ipAddress || "0.0.0.0",
        deviceType: TYPE?.DEVICE_TYPE,
      };

      dispatch(saveSignUpDetails(data));

      try {
        const response = await dispatch(forgotEmailAction(data));
        if (response?.status === 200) {
          history(ROUTES.SECURITY_VERIFICATION);
        }
      } catch (error) {
        console.log("Something went wrong:", error);
      } finally {
        submitLockRef.current = false;
        setSubmitPending(false);
      }
    },
  });

  useEffect(() => {
    ipGet();
  }, []);

  const ipGet = async () => {
    let data = await publicIpv4();
    setIpAddress(data);
  };

  return (
    <>
      <div className={`${styles.onboard_box} ${passwordStyles.password_box}`}>

        <Button
          variant='without_bg_border'
          className='backbtn'
          type="button"   // ✅ fixed (was submit)
          onClick={() => navigate(-1)}
        >
          <LeftArrowIcon />
          Back
        </Button>

        <h2>Forgot Password</h2>

        <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
          <InputFormik
            className={styles.input}
            control="input"
            type="text"
            name="email"
            placeholder="Please enter your registered email"
            label="Registered Email "
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur} // ✅ fixed
            formik={formik}
          />

          <div className={`${styles.submit_btn}`}>
            <Button
              fluid
              type="button"
              onClick={(e) => {
                formik.handleSubmit(e);
              }}
              disabled={submitPending || formik.isSubmitting}
              loading={submitPending}
            >
              Continue
            </Button>
          </div>

        </form>
      </div>
    </>
  );
};

export default ForgotPasswordEmail;